import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/inventory/challans")({
  component: ChallansPage,
});

import { useState } from "react";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import PageHeader from "@/components/reusable-components/header/page-header";
import FiltersPanel from "@/components/reusable-components/header/filter-pannel";
import { SelectFilter } from "@/components/crud/filters/SelectFilter";
import { PaginationComponent } from "@/components/crud/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "@/lib/constants";
import { usePaginationState } from "@/hooks/ui/usePaginationState";
import { useFetchChallans } from "@/hooks/api/inventory/useStockOps";
import { ChallanTable } from "@/components/inventory/tables/ChallanTable";
import { ChallanDetailSheet } from "@/components/inventory/forms/DetailViewSheet";
import type { ChallanStatus, DeliveryChallan } from "@/types/inventory";

const STATUS_OPTIONS = [
  { label: "Created", value: "CREATED" },
  { label: "Dispatched", value: "DISPATCHED" },
  { label: "Delivered", value: "DELIVERED" },
] satisfies { label: string; value: ChallanStatus }[];

function ChallansPage() {
  const navigate = useNavigate();

  const { page, setPage, pageSize, handlePageSizeChange } =
    usePaginationState();
  const [showFilters, setShowFilters] = useState(false);
  const [statusFilter, setStatusFilter] = useState<ChallanStatus | undefined>(
    undefined
  );
  const [viewing, setViewing] = useState<DeliveryChallan | null>(null);

  const challansQuery = useFetchChallans({
    page_size: pageSize,
    page,
    status: statusFilter,
  });
  const challans = challansQuery.data?.results ?? [];
  const count = challansQuery.data?.count ?? 0;
  const isLoading = challansQuery.isPending;
  const isFetching = challansQuery.isFetching;

  const resetFilters = () => {
    setStatusFilter(undefined);
    setPage(1);
  };

  return (
    <SidebarInset>
      <DashboardHeader />
      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Delivery Challans"
          description="View auto-generated delivery challans from issued requisitions"
          onToggleFilter={() => setShowFilters((prev) => !prev)}
          isLoading={isFetching}
        />

        <FiltersPanel
          show={showFilters}
          onClear={resetFilters}
          isLoading={isFetching}
        >
          <SelectFilter
            placeholder="Status"
            options={STATUS_OPTIONS}
            value={statusFilter}
            onChange={(v) => {
              setStatusFilter(v);
              setPage(1);
            }}
          />
        </FiltersPanel>

        <ChallanTable
          challans={challans}
          isLoading={isLoading}
          onNameClick={(c) =>
            navigate({
              to: "/admin/inventory/challans/$id",
              params: { id: String(c.id) },
            })
          }
          onView={(c) => setViewing(c)}
        />
        <PaginationComponent
          count={count}
          page={page}
          onPageChange={setPage}
          isLoading={isFetching}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
        />
      </div>

      <ChallanDetailSheet
        isOpen={!!viewing}
        onClose={() => setViewing(null)}
        challan={viewing}
      />
    </SidebarInset>
  );
}
